export default "__VITE_ASSET__DLBe3_bA__"